import React from 'react'
import { Box, Tooltip, SxProps, Theme } from '@mui/material'
import useTooltipEnabled from 'Hooks/useTooltipEnabled'

interface AccessibleImageProps {
  src: string
  alt: string
  tooltipTitle?: string
  sx?: SxProps<Theme>
}

export const AccessibleImage = ({
  src,
  alt,
  tooltipTitle,
  sx,
}: AccessibleImageProps) => {
  const tooltipEnabled = useTooltipEnabled()
  const title = tooltipTitle ?? alt

  return (
    <Tooltip
      title={title}
      placement='top'
      arrow
      disableHoverListener={!tooltipEnabled}
      disableFocusListener={!tooltipEnabled}
      disableTouchListener={!tooltipEnabled}
    >
      <Box
        component='img'
        src={src}
        alt={alt}
        tabIndex={0}
        sx={sx}
      />
    </Tooltip>
  )
}

export default AccessibleImage
